<template>
  <el-container class="home-wrap">
    <el-main v-if="!isSetting" class="full-content app-times-table">
      <div class="flex-row-end appstime-header">
        <div class="flex-row-center">
          <div class="appstime_header_hide" style="width:40%;">Name</div>
          <div class="appstime_header_hide" style="width:50%">Used</div>
        </div>
        <!-- <el-select v-model="value" size="mini" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </div>
      <div v-if="!NoData" class="appdatas_hide" style="height:calc(100% - 70px);" v-loading="isloading">
        <el-table
          :data="AppDatas"
          @sort-change="onSortChange"
          :default-sort="{prop: 'timeLengthTwo.timeLen', order: 'descending'}"
          cell-class-name="aside-table-app"
          style="width: 100%;height:100%;overflow-y:scroll;padding:0 10px;font-size: 20px;color: #333333;">
          <el-table-column prop="title" :label="$t('Name')" min-width='100%' style="color: #333333;">
            <template slot-scope="scope">
              <div class="flex-row-start">
                <div class="name-and-icon"><img :src="scope.row.img" alt="" ></div>
                <div class="name-and-icon-text">{{scope.row.title}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="TotalTime" sortable :label="$t('Used Time')">
            <template slot-scope="scope">
              <div class="flex-row-start">
                <div class="text-ellipsis">{{dateFormatter(scope.row.TotalTime)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="timeLengthTwo.timeLen" :label="$t('Duration Limit')">
            <template slot-scope="scope">
              <div class="flex-col-start-left">
                <div class="text-ellipsis">{{scope.row.timeLengthTwo && dateFormatterMin(scope.row.timeLengthTwo.timeLen)}}</div>
                <div class="text-ellipsis">{{scope.row.timeLengthTwo && dateFormatterDays(scope.row.timeLengthTwo.days)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="timeLengthOne.startTime" :label="$t('Restricted Period')">
            <template slot-scope="scope">
              <div class="flex-col-start-left">
                <div class="text-ellipsis">{{scope.row.timeLengthOne && scope.row.timeLengthOne.startTime}} {{scope.row.timeLengthOne && scope.row.timeLengthOne.endTime}}</div>
                <div class="text-ellipsis">{{scope.row.timeLengthOne && dateFormatterDaysOne(scope.row.timeLengthOne.days)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Set Limits')">
            <template slot-scope="scope">
              <div class="apptime-edit" @click="onSetCurrent(scope.row)"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="!NoData" class="appdatas_show" style="height:calc(100% - 70px);" v-loading="isloading">
        <el-table
          :data="AppDatas"
          @sort-change="onSortChange"
          :default-sort="{prop: 'timeLengthTwo.timeLen', order: 'descending'}"
          cell-class-name="aside-table-app"
          style="width: 100%;height:100%;overflow-y:scroll;padding:0 10px;font-size: 20px;color: #333333;">
          <el-table-column prop="title">
            <template slot-scope="scope">
              <div class="flex-row-start">
                <div class="name-and-icon"><img :src="scope.row.img" alt="" ></div>
                <div class="flex_col_nostart appdatas_show_title">
                  <div class="flex-row-between">
                    <div class="name-and-icon-text">{{scope.row.title}}</div>
                    <div class="text-ellipsis">{{dateFormatter(scope.row.TotalTime)}}</div>
                  </div>
                  <div class="text_ellipsis">{{scope.row.timeLengthTwo && dateFormatterMin(scope.row.timeLengthTwo.timeLen)}}{{scope.row.timeLengthOne && scope.row.timeLengthOne.startTime}} {{scope.row.timeLengthOne && scope.row.timeLengthOne.endTime}}</div>
                </div>
                <div>
                  <div class="apptime-edit" @click="onSetCurrent(scope.row)"></div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else class="flex-col-center buy-main">
        <div><img :src="$Image('nodata.png')" alt=""></div>
        <div class="nodata-found">{{$t('No data found')}}</div>
      </div>
    </el-main>
    <el-main v-else class="flex-row-between iphone_col_setexcapp">
      <div class="setItems">
        <SetUsageTime v-on:onSaveUseTime="onSaveUseTime" @onCancel="onCancel" :OneRow="this.OneRow" :isPeriod="false"></SetUsageTime>
      </div>
      <div class="setItems">
        <SetUsageTime v-on:onSaveUsePeriod="onSaveUsePeriod" @onCancel="onCancel" :OneRow="this.OneRow" :isPeriod="true"></SetUsageTime>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import SetUsageTime from './Common/SetUsageTime.vue'
export default {
  name: 'apps-time',
  props: ['userid', 'device'],
  data () {
    return {
      value: 0,
      options: [
        { label: 'Today', value: 0 },
        { label: 'Yesterday', value: 1 },
        { label: 'Last three days', value: 3 },
        { label: 'Last seven days', value: 7 }
      ],
      appTimeDatas: [],
      isSetting: false,
      isloading: false,
      NoData: false,
      AppDatas: null,
      AppDatasTwo: null,
      getAppActivityDatas: null,
      timesDatas: null,
      alltimesDatas: null,
      OneRow: null,
      sortGroup: '',
      order: ''
    }
  },
  components: { SetUsageTime },
  methods: {
    onSortChange (currentChange) {
      this.sortGroup = currentChange.prop
      this.order = currentChange.order
      // this.getAppDatas()
    },
    async getAppDatas () {
      try {
        // 获取活跃APP
        this.isloading = true
        const datasOne = await this.$http.get(`MDM/AppActivity?date=Today`)
        this.getAppActivityDatas = datasOne.data.data
        console.log(this.getAppActivityDatas)
        // 获取APP的限制时间
        const times = await this.$http.get('MDM/ScheduleRestriction')
        this.timesDatas = times.data.data
        console.log(times.data.data)
        // 获取所有APP
        const datas = await this.$http.get(`MDM/Applications?id${this.$route.params.device}`)
        this.AppDatas = datas.data.data
        this.AppDatas = this.contontObj(this.AppDatas, this.getAppActivityDatas, 'TotalTime')
        this.AppDatas = this.contontObj(this.AppDatas, this.timesDatas, 'all')
        this.AppDatas.map((d) => {
          // let timeLengthOnes = d.timeLength.filter(c => c.timeLen === null)
          // console.log(timeLengthOnes)
          // if (timeLengthOnes.length !== 0) {
          //   d.timeLengthOne = timeLengthOnes[0]
          // } else {
          //   d.timeLengthOne = {}
          // }
          // console.log(d.timeLengthOne)
          // let timeLengthTwos = d.timeLength.filter(c => c.startTime === null)
          // if (timeLengthTwos.length !== 0) {
          //   d.timeLengthTwo = timeLengthTwos[0]
          // } else {
          //   d.timeLengthTwo = {}
          // }
          // console.log(timeLengthTwos)
          // console.log(d.timeLengthTwo)
          for (let i = 0; i < d.timeLength.length; i++) {
            if (d.timeLength[i].timeLen === null) {
              d.timeLengthOne = d.timeLength[i]
            } else if (d.timeLength[i].startTime === null && d.timeLength[i].endTime === null) {
              d.timeLengthTwo = d.timeLength[i]
            }
          }
        })
        this.isloading = false
        console.log(this.AppDatas)
      } catch (error) {
        this.NoData = true
      }
    },
    // 将b数组内的对象判断是否与q数组内的对象存着相同的packname，若果有则将该对象合并。
    contontObj (q, b, type) {
      q = (q || []).map((c) => {
        if (c.img.indexOf(this.STS_URL)) {
          c.img = `${this.STS_URL}` + '/' + c.title + '.png'
        }
        let allobj = ''
        c['timeLength'] = []
        for (let a = 0; a < b.length; a++) {
          if (type === 'all') {
            // console.log(c.packname, b[a].title)
            if (c.packname === b[a].title) {
              c['timeLength'].push(b[a])
              allobj = {...c}
            }
          } else {
            if (c.packname === b[a].PackName) {
              allobj = {...c, TotalTime: b[a][type]}
            }
          }
        }
        if (allobj === '') {
          return c
        } else {
          c = allobj
          return c
        }
      })
      return q
    },
    // 把对应的App数据传给 限制页面
    async onSetCurrent (row) {
      console.log('row:', row)
      this.OneRow = row
      this.isSetting = true
    },
    dateFormatter: function (aDate) {
      let date = this.$Formatter.duration(aDate / 1000)
      return date
    },
    dateFormatterMin: function (aDate) {
      let date = this.$Formatter.durationOne(aDate * 60)
      return date
    },
    dateFormatterDays: function (days) {
      // let day = days.join()
      if (typeof (days) === 'string') {
        let reg = /^\[|\]$/ig
        if (reg.test(days)) {
          days = days.replace(reg, '')
          return days
        }
      } else {
        let day = days.join()
        return day
      }
    },
    dateFormatterDaysOne: function (daysOne) {
      if (typeof (daysOne) === 'string') {
        let reg = /^\[|\]$/ig
        if (reg.test(daysOne)) {
          daysOne = daysOne.replace(reg, '')
          return daysOne
        }
      } else {
        let day = daysOne.join()
        return day
      }
      // let day = daysOne.join()
      // return daysOne
    },
    // 时长保存逻辑
    async onSaveUseTime (obj) {
      // console.log(obj.setUserTime)
      // console.log(this.OneRow.timeLengthTwo)
      let weeks = '[' + obj.weeks.toString() + ']'
      if (this.OneRow.timeLengthTwo === undefined) {
        const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
          params: {
            timelen: obj.setUserTime,
            name: this.OneRow.packname,
            week: weeks
          }
        })
        console.log(datas)
        this.getAppDatas()
      } else {
        if (obj.repeatValue === false || obj.limitValue === false) {
          const datasDelete = await this.$http.get('MDM/ScheduleRestriction/Delete', {
            params: {
              id: this.OneRow.timeLengthTwo.id
            }
          })
          this.getAppDatas()
          console.log(datasDelete)
        } else {
          const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
            params: {
              timelen: obj.setUserTime,
              name: this.OneRow.packname,
              id: this.OneRow.timeLengthTwo.id,
              week: weeks
            }
          })
          console.log(datas)
          this.getAppDatas()
        }
      }
      this.isSetting = false
    },
    // 时断的保存逻辑
    async onSaveUsePeriod (obj) {
      // 如果是空数据就添加
      let weeksTwo = '[' + obj.weeksTwo.toString() + ']'
      if (this.OneRow.timeLengthOne === undefined) {
        const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
          params: {
            starthour: obj.startValue,
            endhour: obj.endValue,
            name: this.OneRow.packname,
            week: weeksTwo
          }
        })
        console.log(datas)
        this.getAppDatas()
      } else {
        // 如果有数据就传相对于的id，修改。
        if (obj.repeatValueTwo === false || obj.limitValueTwo === false) {
          const datasDelete = await this.$http.get('MDM/ScheduleRestriction/Delete', {
            params: {
              id: this.OneRow.timeLengthOne.id
            }
          })
          this.getAppDatas()
          console.log(datasDelete)
        } else {
          const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
            params: {
              starthour: obj.startValue,
              endhour: obj.endValue,
              name: this.OneRow.packname,
              id: this.OneRow.timeLengthOne.id,
              week: weeksTwo
            }
          })
          console.log(datas)
          this.getAppDatas()
        }
      }
      this.isSetting = false
    },
    onCancel (t) {
      if (t === true) {
        this.isSetting = false
        this.getAppDatas()
      }
    }
  },
  mounted () {
    this.getAppDatas()
  },
  created () {
    this.getAppDatas()
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
      if (to.name === from.name) {
        this.getAppDatas()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-wrap{
  width:100%;
  box-sizing: border-box;
  .app-times-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .appstime-header{
      width:100%;
      height:70px;
      padding-right:15px;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      .el-input--mini .el-input__inner{
        width:160px;
        height:36px;
        border-radius:18px;
      }
    }
    .name-and-icon{
      width:48px;
      height:48px;
      border-radius:10px;
      overflow:hidden;
      img{
        width:48px;
        height:48px;
      }
    }
    .name-and-icon-text{
      margin-left:15px;
      font-size: 18px;
    }
    .apptime-edit{
      width:28px;
      height:28px;
      cursor: pointer;
      background:url('../../static/images/edit.png') 0 0 no-repeat;
      &:hover{
        background:url('../../static/images/edit_hover.png') 0 0 no-repeat;
      }
    }
  }
  .setItems{
    width:48%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
  }
}
.buy-main {
  width: 100%;
  height: 75%;
}
.nodata-found{
  font-size: 18px;font-weight: normal;line-height: 54px;color: #777777;margin-top: 20px;
}
.text-ellipsis{
  font-size: 16px;
  color: #333333;
}
.appstime_header_hide {
    display: none;
    text-align: left;color: #333333;font-size: 18px;
}
.appdatas_hide {
  display: block;
}
.appdatas_show {
  display: none;
}
@media (min-width: 1280px){
  .home-wrap{
    height:90%;
  }
}
@media (max-width: 1024px){
  .home-wrap .app-times-table {
    height: 750px;
  }
  .name-and-icon-text {
    text-align: left;
    margin-left: 0 !important;
  }
  .appstime_header_hide {
    display: inline-block;
  }
  .appdatas_hide {
    display: none;
  }
  .appdatas_show {
    display: block;
  }
  .appdatas_show {
    .appdatas_show_title{
      width: 70%;
      padding: 0 20px;
    }
    .text_ellipsis{
      font-size: 14px;
      color: #888888;
    }
  }
  .iphone_col_setexcapp{
    flex-flow: column nowrap;
  }
 .home-wrap .setItems{
    width: 98%;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppsTime.vue